module.exports = __webpack_public_path__ + "img/np.2b70d21d.svg";